<div
  class="paragraph"
  *ngIf="error">
  {{ errorMessage }}
  <a
    *ngIf="ssoFailed"
    href="#"
    (click)="restartSso($event)"
    >Sign in again</a
  >
  <a
    *ngIf="!ssoFailed"
    href="#"
    (click)="reloadThisPage($event)"
    >Reload</a
  >
  |
  <a
    href="#"
    (click)="rememberLastSession($event)"
    >Back to Client/Matter Profile</a
  >
</div>
